export default __webpack_public_path__ + "static/Average May temp 2010-757f4b37d3716743e39320b3222f6950.png";